import {Component, ChangeDetectionStrategy, SimpleChanges, OnChanges} from '@angular/core';
import {FormBuilder } from '@angular/forms';

import {GenericFieldset, IGenericFieldset} from '../generic-fieldset.component';
import {Yii} from "libraries/interfaces/Yii";

/**
 * Keyword-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({
    selector: 'keyword-fieldset',
    templateUrl: './keyword-fieldset.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeywordFieldsetComponent extends GenericFieldset implements IGenericFieldset, OnChanges {
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'price';

    public placeholder: string = Yii.t('wui-shared-js', 'Aucun service');

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder) {
        super(fb);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.fieldsetData &&
            changes.fieldsetData.currentValue) {
            this.group.get('keyword').patchValue(changes.fieldsetData.currentValue);
        }
    }
}
